import React from 'react'
import ReactMarkdown from 'react-markdown'
import { useStyles } from './StandFirst.styles'
import { Link } from '@material-ui/core'
import { PluggableList } from 'unified'
import rehypeRaw from 'rehype-raw'

interface IIntroTemplateProps {
  text: string
}

export const StandFirst = ({ text }: IIntroTemplateProps) => {
  const classes = useStyles()
  const renderers = {
    link: (props) => <Link href={props.href}>{props.children}</Link>
  }

  return (
    <ReactMarkdown className={classes.standFirst} components={renderers} rehypePlugins={[rehypeRaw] as PluggableList}>
      {text}
    </ReactMarkdown>
  )
}
